import './home.css';

import * as React from 'react';

import { connect } from 'react-redux';
import { BrowserComp } from '../browser-comp/browser-comp';
import { ImageComp } from '../image-comp/image-comp';
import ManualSelectComp from '../manual-select-comp/manual-select-comp';

import { getSession } from 'app/shared/reducers/authentication';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { getEntities as getBooks } from 'app/entities/book/book.reducer';
import { getEntities as getSports } from 'app/entities/sport/sport.reducer';
import { getEntitiesByUserIsCurrentUser as getBookSubscriptions } from 'app/entities/book-subscription/book-subscription.reducer';
import { IRootState } from 'app/shared/reducers';
import { getEntity as getBettingBookAuthToken } from 'app/entities/betting-book-auth-token/betting-book-auth-token.reducer';
import axios from 'axios';

export interface IHomeProp extends StateProps, DispatchProps, RouteComponentProps<{ id: number; index: number }> {}

export interface IHomeState {
  bettingBookAuthToken: string;
  dataLoaded: boolean;
  readMode: boolean;
}

export class Home extends React.Component<IHomeProp, IHomeState> {
  state: IHomeState = {
    bettingBookAuthToken: null,
    dataLoaded: false,
    readMode: false
  };

  componentDidMount() {
    // A refresh or direct link starts with an empty store, so wait for the data before checking access
    const requests: any[] = [this.props.getBooks(), this.props.getBookSubscriptions(), this.props.getSports()];
    const finish = () => this.setState({ dataLoaded: true });
    Promise.all(requests).then(finish, finish);
    this.updateAuthToken();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.updateAuthToken();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.classList.remove('is-reading');
  }

  setReadMode = (readMode: boolean) => {
    this.setState({ readMode });
    document.body.classList.toggle('is-reading', readMode);
    if (readMode) {
      document.addEventListener('keydown', this.handleKeyDown);
    } else {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  };

  enterReadMode = () => this.setReadMode(true);

  exitReadMode = () => this.setReadMode(false);

  handleKeyDown = event => {
    if (event.key === 'Escape') {
      this.exitReadMode();
    }
  };

  updateAuthToken = () => {
    axios.get(`/api/bettingbookauthtoken/${this.props.account.email}`).then(response => {
      this.setState({
        bettingBookAuthToken: response.data
      });
    });
  };

  getBooksArray = booksList => {
    const bookArray = new Array();
    booksList.forEach((book, bookIndex) => {
      bookArray.push(book);
    });
    return bookArray;
  };

  getBookById = (id, bookArray) => {
    let result = null;
    bookArray.forEach((item, index) => {
      if (item.id === parseInt(id, 10)) {
        result = bookArray[index];
      }
    });
    return result;
  };

  getAllShownBookIds(bookSubscriptionList, bookArray) {
    const allShownBooks = [];

    bookSubscriptionList.filter(x => x.isActive === true).forEach(sub => allShownBooks.push(sub.book.id));

    bookArray.filter(x => x.isFree === true).forEach(book => allShownBooks.push(book.id));

    return allShownBooks;
  }

  render() {
    const { account, bookList, bookSubscriptionList, sportList } = this.props;

    if (!this.props.isAuthenticated) {
      return <Redirect to="/login" />;
    }
    // Coming from the dashboard the store is already filled, so open the book while it refreshes
    const hasStoredData = bookList.length > 0 && sportList.length > 0 && bookSubscriptionList.length > 0;
    if (!this.state.dataLoaded && !hasStoredData) {
      return null;
    }
    if (bookList.length > 0) {
      const bookArray = this.getBooksArray(bookList);
      const book = this.getBookById(this.props.match.params.id, bookArray);
      const allShownBooks = this.getAllShownBookIds(bookSubscriptionList, bookArray);
      if (!allShownBooks.includes(parseInt(String(this.props.match.params.id), 10))) {
        return <Redirect to="/dashboard" />;
      }
      return (
        <div className={this.state.readMode ? 'home-page is-reading-page' : 'home-page'}>
          <div className="home-header">
            <ManualSelectComp
              firstName={account.firstName}
              lastName={account.lastName}
              bookSubscriptionList={bookSubscriptionList}
              sportList={sportList}
              selectedBookId={this.props.match.params.id}
              bookList={bookList}
              onReadMode={this.enterReadMode}
            />
          </div>
          <div className="book-banner">
            <ImageComp imageName={book.bannerName} height="140px" alt={book.name} />
          </div>
          <div className="book-reader">
            {this.state.bettingBookAuthToken != null ? (
              <BrowserComp
                iframeKey={this.props.match.params.index}
                manualUrl={book.bookUrl}
                email={account.email}
                token={this.state.bettingBookAuthToken}
              />
            ) : null}
            {this.state.readMode ? (
              <button type="button" className="reader-exit" onClick={this.exitReadMode} autoFocus>
                Exit Read Mode
              </button>
            ) : null}
          </div>
        </div>
      );
    }
    return <Redirect to="/dashboard" />;
  }
}

const mapStateToProps = ({ authentication, book, bookSubscription, sport }: IRootState) => ({
  account: authentication.account,
  isAuthenticated: authentication.isAuthenticated,
  bookList: book.entities,
  bookSubscriptionList: bookSubscription.entities,
  sportList: sport.entities
});

const mapDispatchToProps = {
  getSession,
  getBooks,
  getSports,
  getBookSubscriptions,
  getBettingBookAuthToken
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Home);
